import {
  productAddPath,
  productDeletePath,
  productFindAllPageablePath,
  productFindAllPath,
  productFindByIdPath,
  productFindByIdWithLogoPath,
  productUpdatePath,
  productUpdateWithLogoPath,
} from '../constants/apiEndpoints';
import { ModalForAddOrUpdateProduct } from '../enums/ProductEnums';
import { handleServerErrorMessage, handleServerSuccessMessage } from '../utils';
import apiService from '../utils/apiService';
import {
  ADD_PRODUCT,
  ADD_PRODUCT_ERROR,
  ADD_PRODUCT_START,
  CLEAR_ERROR_PRODUCT,
  DELETE_PRODUCT,
  DELETE_PRODUCT_ERROR,
  DELETE_PRODUCT_START,
  GET_PRODUCT,
  GET_PRODUCT_ERROR,
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_ERROR,
  GET_PRODUCT_LIST_PAGEABLE,
  GET_PRODUCT_LIST_PAGEABLE_ERROR,
  GET_PRODUCT_LIST_PAGEABLE_START,
  GET_PRODUCT_LIST_START,
  GET_PRODUCT_START,
  GET_PRODUCT_WITH_LOGO,
  GET_PRODUCT_WITH_LOGO_ERROR,
  GET_PRODUCT_WITH_LOGO_START,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_ERROR,
  UPDATE_PRODUCT_START,
} from './types';

const clearError = () => {
  return {
    type: CLEAR_ERROR_PRODUCT,
  };
};

//ADD
const addProductStart = () => {
  return {
    type: ADD_PRODUCT_START,
  };
};
const addProductSuccessfully = (data) => {
  return {
    type: ADD_PRODUCT,
    payload: data,
  };
};
const addProductUnsuccessfully = (err) => {
  return {
    type: ADD_PRODUCT_ERROR,
    payload: err,
  };
};

//UPDATE
const updateProductStart = () => {
  return {
    type: UPDATE_PRODUCT_START,
  };
};

const updateProductSuccessfully = (data) => {
  return {
    type: UPDATE_PRODUCT,
    payload: data,
  };
};

const updateProductUnsuccessfully = (err) => {
  return {
    type: UPDATE_PRODUCT_ERROR,
    payload: err,
  };
};

//GET

const getProductStart = () => {
  return {
    type: GET_PRODUCT_START,
  };
};

const getProductSuccessfully = (data) => {
  return {
    type: GET_PRODUCT,
    payload: data,
  };
};

const getProductUnsuccessfully = (err) => {
  return {
    type: GET_PRODUCT_ERROR,
    payload: err,
  };
};

//GET LIST
const getProductListStart = () => {
  return {
    type: GET_PRODUCT_LIST_START,
  };
};

const getProductListSuccsessfully = (data) => {
  return {
    type: GET_PRODUCT_LIST,
    payload: data,
  };
};

const getProductListUnsuccessfully = (err) => {
  return {
    type: GET_PRODUCT_LIST_ERROR,
    payload: err,
  };
};

//DELETE

const deleteProductStart = () => {
  return {
    type: DELETE_PRODUCT_START,
  };
};

const deleteProductSuccessfully = (data) => {
  return {
    type: DELETE_PRODUCT,
    payload: data,
  };
};

const deleteProductUnsuccessfully = (err) => {
  return {
    type: DELETE_PRODUCT_ERROR,
    payload: err,
  };
};

//PAGEABLE
const getProductPageableListStart = () => {
  return {
    type: GET_PRODUCT_LIST_PAGEABLE_START,
  };
};

const getProductPageableListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_PRODUCT_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};

const getProductListPageableUnsuccessfully = (err) => {
  return {
    type: GET_PRODUCT_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};

// GET WITH LOGO
const getProductWithLogoStart = () => {
  return {
    type: GET_PRODUCT_WITH_LOGO_START,
  };
};

const getProductWithLogoSuccessfully = (data) => {
  return {
    type: GET_PRODUCT_WITH_LOGO,
    payload: data,
  };
};

const getProductWithLogoUnsuccessfully = (err) => {
  return {
    type: GET_PRODUCT_WITH_LOGO_ERROR,
    payload: err,
  };
};

//ADD
export const createProduct = (product, callback) => {
  return (dispatch) => {
    dispatch(addProductStart());
    return apiService
      .post(productAddPath(), product)
      .then((response) => {
        dispatch(addProductSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateProduct.saveSuccessMessage,
          product
        );
        callback();
      })
      .catch((err) => {
        dispatch(addProductUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.response?.data
        );
      });
  };
};

//UPDATE
export const updateProduct = (product, callback) => {
  return (dispatch) => {
    dispatch(updateProductStart());
    return apiService
      .put(productUpdatePath(), product)
      .then((response) => {
        dispatch(updateProductSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateProduct.updateSuccessMessage,
          product
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateProductUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.response?.data
        );
      });
  };
};

//UPDATE WITH LOGO
export const updateProductWithLogo = (formData, callback) => {
    return (dispatch) => {
        dispatch(updateProductStart());
        return apiService
            .put(productUpdateWithLogoPath(), formData)
            .then((response) => {
                dispatch(updateProductSuccessfully(response.data));
                handleServerSuccessMessage(
                    ModalForAddOrUpdateProduct.updateSuccessMessage,
                    response.data);
                callback();
            })
            .catch((err) => {
                dispatch(updateProductUnsuccessfully(err.response.data));
                handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
            });
    };
};

//FIND BY ID

export const findProductById = (id) => {
  return (dispatch) => {
    dispatch(getProductStart());
    return apiService
      .get(productFindByIdPath(id))
      .then((response) => {
        dispatch(getProductSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getProductUnsuccessfully(err));
      });
  };
};

// FIND BY ID WITH LOGO
export const findProductByIdWithLogo = (id) => {
  return (dispatch) => {
    dispatch(getProductWithLogoStart());
    return apiService
      .get(productFindByIdWithLogoPath(id))
      .then((response) => {
        dispatch(getProductWithLogoSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getProductWithLogoUnsuccessfully(err));
      });
  };
};

//FIND ALL

export const findAllProducts = () => {
  return (dispatch) => {
    dispatch(getProductListStart());
    return apiService
      .get(productFindAllPath())
      .then((response) => {
        dispatch(getProductListSuccsessfully(response.data));
      })
      .catch((err) => {
        dispatch(getProductListUnsuccessfully(err));
      });
  };
};

//DELETE

export const deleteProduct = (id) => {
  return (dispatch) => {
    dispatch(deleteProductStart());
    return apiService
      .delete(productDeletePath(id))
      .then(() => {
        dispatch(deleteProductSuccessfully(id));
        handleServerSuccessMessage(
          ModalForAddOrUpdateProduct.deleteSuccessMessage,
          { id }
        );
      })
      .catch((err) => {
        dispatch(deleteProductUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.respoonse?.status === 404
            ? ServerMessagesEnums.deleteErrorMessage404
            : err?.response?.data
        );
      });
  };
};

export const deleteErrorProduct = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

//FIND ALL PAGEABLE
export const findAllProductsPageable = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getProductListStart());
    return apiService
      .get(productFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        dispatch(
          getProductPageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getProductListUnsuccessfully(err));
      });
  };
};
